import { createContext } from 'react'

/** One per stack item: a modal that takes over from another of its item (the loading one, say) does not open anew. */
export type ModalTransition = {
  isShown: () => boolean
  markShown: () => void
}

export const ModalTransitionContext = createContext<ModalTransition | null>(null)

export const createModalTransition = (): ModalTransition => {
  let shown = false
  return {
    isShown: () => shown,
    markShown: () => {
      shown = true
    },
  }
}
